import {
	Avatar,
	Box,
	Card,
	CardContent,
	LinearProgress, makeStyles, Typography
} from '@material-ui/core';
import React from 'react';
import { useActions, useValues } from 'kea';
import profilelogic from 'src/store/profile';


const useStyles = makeStyles(() => ({
	root: {
		height: '100%',
		width: '100%'
	},
	avatar: {
		marginTop: '40px',
		height: 100,
		width: 100
	}
}));

const Profile = () => {
	const classes = useStyles();

	const { profile } = useValues(profilelogic);

	return (
		<Card
			className={classes.root}
		>
			<CardContent>
				<Box
					alignItems="center"
					display="flex"
					flexDirection="column"
				>
					<Avatar
						className={classes.avatar}
					/>
					<Typography
						color="textPrimary"
						gutterBottom
						variant="h3"
					>
						{`${profile?.first_name} ${profile?.last_name}`}
					</Typography>
					<Typography
						color="textSecondary"
						variant="body1"
					>
						{profile?.job_title}
					</Typography>
					<Typography
						className={classes.dateText}
						color="textSecondary"
						variant="body1"
					>
						{profile?.email}
					</Typography>
				</Box>
			</CardContent>
		</Card>
	);
};


export default Profile;
